import type { AddOnRegistrantInput } from "../api/registration";

export interface RegistrationPaperEntry {
  paperId: string;
  paperTitle: string;
  paperCount: string;
  /** paper_plus_addon (idass/icast) only — each paper can have its own co-registrants. */
  addOnRegistrants?: AddOnRegistrantInput[];
}

export const PAPER_STORAGE_SEPARATOR = "; ";

export function syncPaperCount(
  papers: RegistrationPaperEntry[],
  totalCount: number,
): RegistrationPaperEntry[] {
  const next = [...papers];
  while (next.length < totalCount) {
    next.push({ paperId: "", paperTitle: "", paperCount: "" });
  }
  return next.slice(0, totalCount);
}

export function paperCountsFromEntries(
  papers: RegistrationPaperEntry[],
): number[] {
  return papers
    .map((paper) => parseInt(paper.paperCount.trim(), 10))
    .filter((count) => Number.isInteger(count) && count > 0);
}

export function papersToDraftInput(
  papers: RegistrationPaperEntry[],
): Array<{
  paperId: string;
  paperTitle: string;
  paperCount: number;
  addOnRegistrants?: AddOnRegistrantInput[];
}> {
  return papers.map((paper) => ({
    paperId: paper.paperId.trim(),
    paperTitle: paper.paperTitle.trim(),
    paperCount: parseInt(paper.paperCount.trim(), 10),
    ...(paper.addOnRegistrants ? { addOnRegistrants: paper.addOnRegistrants } : {}),
  }));
}
